import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';

// components
import Form from '../../components/Form/Form';
import Button from '../../components/Button/Button';
import getItems from '../../api/cars/getItems';
import getFactoryList from '../../api/cars/getFactoryList';
import getTransmissions from '../../api/shop/getTransmissions';
import getContainers from '../../api/cars/getContainers';
import { useNavigate, useParams } from 'react-router-dom';
import checkCrmSidebarNotifications from '../../api/notifications/checkCrmSidebarNotifications';
import HookForm from '../../components/HookForm/HookForm';
import ForeignCityNotice from '../../components/ForeignCity/ForeignCityNotice';
import SelectMarks from '../../components/Selects/SelectMarks';
import SelectModels from '../../components/Selects/SelectModels';
import SelectComplectations from '../../components/Selects/SelectComplectations';
import Loader from '../../components/Loader/Loader';
import checkStockCar from '../../utils/checkStockCar';
import SelectCarTransmissions from '../../components/Selects/SelectCarTransmissions';
import formatNumber from '../../utils/formatNumber';
import SelectCity from '../../components/Selects/SelectCity';
import SelectDc from '../../components/Selects/SelectDc';
import Datepicker from '../../components/Inputs/Datepicker/Datepicker';
import editCar from '../../api/cars/editCar';
import alert from '../../helpers/alert';
import dayjs from 'dayjs';
import {
  CAR_ORIGIN_LABELS,
  CAR_ORIGIN_TYPES,
  USED_CAR_FACTORY_ID,
  PURCHASE_PROCESS_TYPES,
  isConsignmentOrigin,
} from '../../constants/carOrigin';
import sortFactoryList from '../../utils/sortFactoryList';
import { originAvailable } from '../../brand/tenant';
import Select from '../../components/Select/Select';

const formStyles = {
  carInfo: { display: 'grid', gap: '20px', gridTemplateColumns: `1fr 1fr 1fr 1fr`, alignItems: 'flex-end' },
  dealerInfo: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' },
  other: { display: 'grid', gap: '20px' },
};

// ÐÐ±ÑÑÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ ÑÑÐ°Ð½Ð¸ÑÑÑ Ð² Ð´Ð²ÑÑ Ð¼ÐµÑÑÐ°Ñ: Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð¼Ð°ÑÐ¸Ð½Ñ â Ð² ÐºÑÐ±Ð¸ÑÐµÑÐºÐ¸Ñ
// ÑÐ°Ð½ÑÐ¸Ð¼ÐµÑÑÐ°Ñ, Ð² ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ â Ð² Ð»Ð¸ÑÑÐ°Ñ. Ð Ð°ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð¾Ð·Ð½Ð°ÑÐ°ÐµÑ, ÑÑÐ¾ Ð±Ð°Ð½Ðº Ð½Ðµ Ð½Ð°Ð¹Ð´ÑÑ
// Ð¼Ð°ÑÐ¸Ð½Ñ Ð² ÑÐ²Ð¾ÑÐ¼ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÐµÐ³Ð¾ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ¾Ð¹ Ð¿ÑÑÐ¼Ð¾ Ð¿Ð¾Ð´ Ð¿Ð¾Ð»ÐµÐ¼.
const toLiters = (value) => {
  const parsed = Number(String(value ?? '').replace(',', '.').replace(/[^0-9.].*$/, ''));
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return Math.round((parsed > 100 ? parsed / 1000 : parsed) * 10) / 10;
};

// ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð² ÐºÑÐ±Ð¸ÑÐµÑÐºÐ¸Ñ ÑÐ°Ð½ÑÐ¸Ð¼ÐµÑÑÐ°Ñ: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿ÑÐ°Ð²Ð¸Ñ Ð¿Ð¾Ð»Ðµ Ð¸Ð¼ÐµÐ½Ð½Ð¾ Ð² Ð½Ð¸Ñ, Ð¸
// Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð¸Ð· ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð¿ÐµÑÐµÐ½Ð¾ÑÐ¸ÑÑÑ ÐºÐ°Ðº ÐµÑÑÑ, Ð±ÐµÐ· Ð¿ÐµÑÐµÑÑÑÑÐ° Ð² ÑÐ¼Ðµ.
const toCubic = (value) => {
  const liters = toLiters(value);
  if (liters === null) return null;
  const parsed = Number(String(value ?? '').replace(',', '.').replace(/[^0-9.].*$/, ''));
  return parsed > 100 ? Math.round(parsed) : Math.round(liters * 1000);
};

const engineVolumeHint = (car) => {
  const inCard = toLiters(car?.engine_volume);
  const inComplectation = toLiters(car?.complectation?.engine_volume);
  if (inCard === null || inComplectation === null) return undefined;
  if (Math.abs(inCard - inComplectation) <= 0.15) return undefined;

  return `Ð ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ ÑÐºÐ°Ð·Ð°Ð½ Ð¾Ð±ÑÑÐ¼ ${toCubic(car?.complectation?.engine_volume)}, Ð° Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ â ${toCubic(
    car?.engine_volume
  )}. ForteBank Ð½Ðµ Ð½Ð°Ð¹Ð´ÑÑ Ð¼Ð°ÑÐ¸Ð½Ñ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ, ÐµÑÐ»Ð¸ Ð¾Ð±ÑÑÐ¼ Ð½Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´ÑÑ`;
};

const CarMainData = ({ containerId, onSaved }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [carInfo, setCarInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [factoryList, setFactoryList] = useState([]);
  // Ð¡Ð¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸Ðº Ð·Ð°Ð²Ð¾Ð´Ð¾Ð² Ð½Ð° JetQ Ð¿ÑÑÑÐ¾Ð¹ â ÐºÐ°ÑÑÐ¾ÑÐºÐ° Ð½Ðµ Ð´Ð¾Ð»Ð¶Ð½Ð° Ð¶Ð´Ð°ÑÑ ÐµÐ³Ð¾ Ð²ÐµÑÐ½Ð¾.
  const [factoryListLoaded, setFactoryListLoaded] = useState(false);
  const [factoryId, setFactoryId] = useState(null);
  const resolvedContainerIdRef = useRef(null);
  const onSavedRef = useRef(onSaved);
  onSavedRef.current = onSaved;

  const resolveContainerId = async ({ markOption, modelOption }) => {
    if (!markOption?.label || !modelOption?.label) {
      resolvedContainerIdRef.current = null;
      return;
    }
    try {
      const query = `${markOption.label} ${modelOption.label}`;
      const res = await getContainers({ markAndModel: query, page: 1 });
      const container = res?.data?.containers?.[0];
      resolvedContainerIdRef.current = container?.id ?? null;
    } catch (e) {
      console.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸Ñ containerId Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ/Ð¼Ð¾Ð´ÐµÐ»Ð¸', e);
      resolvedContainerIdRef.current = null;
    }
  };

  const dealerInfo = [
    { type: 'input', value: 'Kia DOSCAR', label: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°', disabled: true },
    { type: 'input', value: 'Ð³. ÐÐ»Ð¼Ð°ÑÑ, ÑÐ». ÐÐ»ÐµÐ±ÐµÐºÐ¾Ð²Ð° 10/1', label: 'ÐÐ´ÑÐµÑ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°', disabled: true },
    { type: 'input', value: '01.10.2022', label: 'ÐÐ°ÑÐ° Ð¿ÑÐ¸Ð±ÑÑÐ¸Ñ Ð² Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ', disabled: true },
    { type: 'input', value: '10%', label: 'Ð¡ÐºÐ¸Ð´ÐºÐ° Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð³Ð¾ ÑÐµÐ½ÑÑÐ°', disabled: true },
  ];

  const other = [
    { type: 'input', value: 'ÐÐ°ÑÑÑÐ¶Ð°Ð½ Ð¨Ð°Ð³Ð°Ð±ÑÑÐ´Ð¸Ð½Ð¾Ð²', label: 'Ð¤ÐÐ Ð¾ÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°', disabled: true },
    { type: 'input', value: 'ÐÐ°ÐºÐ¾Ð¹-ÑÐ¾ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹', label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾Ð± Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ðµ', disabled: true },
  ];
  const [car, setCar] = useState({});

  const loadFactoryList = async () => {
    try {
      const response = await getFactoryList();
      if (response?.data?.data) {
        setFactoryList(sortFactoryList(response.data.data));
      }
    } catch (error) {
      console.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ¿Ð¸ÑÐºÐ° Ð·Ð°Ð²Ð¾Ð´Ð¾Ð²:', error);
    } finally {
      setFactoryListLoaded(true);
    }
  };

  const originOptions = useMemo(() => {
    const baseOptions = Object.keys(CAR_ORIGIN_TYPES)
      .filter((key) => CAR_ORIGIN_TYPES[key] !== CAR_ORIGIN_TYPES.NEW_KZ)
      .filter((key) => originAvailable(CAR_ORIGIN_TYPES[key]))
      .map((key) => ({
        value: CAR_ORIGIN_TYPES[key],
        label: CAR_ORIGIN_LABELS[CAR_ORIGIN_TYPES[key]],
      }));

    if (factoryList.length > 0) {
      const factoryOptions = factoryList.map((factory) => ({
        value: `factory_${factory.id}`,
        label: factory.id === USED_CAR_FACTORY_ID ? factory.name : 'ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, ' + factory.name,
        factoryId: factory.id,
        isUsedFactory: factory.id === USED_CAR_FACTORY_ID,
      }));
      return [...factoryOptions, ...baseOptions];
    } else {
      return [
        {
          value: CAR_ORIGIN_TYPES.NEW_KZ,
          label: CAR_ORIGIN_LABELS[CAR_ORIGIN_TYPES.NEW_KZ],
        },
        ...baseOptions,
      ];
    }
  }, [factoryList]);

  const init = useCallback(() => {
    setLoading(true);
    setCarInfo([]);
    getItems({ id: containerId ?? id })
      .then(async (res) => {
        const car = res.data.cars[0];
        setCar(car);

        // Ð Ð°ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð¾Ð±ÑÑÐ¼Ð° Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸ÐµÐ¹ Ð±Ð°Ð½Ðº Ð½Ðµ Ð¿ÑÐ¾ÑÑÐ¸Ñ: Ð¾Ð½ Ð¸ÑÐµÑ Ð¼Ð°ÑÐ¸Ð½Ñ Ð²
        // ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ, Ð¼Ð¾Ð´ÐµÐ»Ð¸, Ð³Ð¾Ð´Ñ Ð¸ Ð¾Ð±ÑÑÐ¼Ñ ÑÑÐ°Ð·Ñ. Ð¡Ð¾Ð¾Ð±ÑÐ°ÐµÐ¼ Ð·Ð´ÐµÑÑ, Ð¿Ð¾ÐºÐ°
        // Ð¼Ð°ÑÐ¸Ð½Ñ Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð»Ð¸ Ð² ÑÐ´ÐµÐ»ÐºÑ â Ð½Ð° ÑÐ°Ð³Ðµ Ð·Ð°ÑÐ²ÐºÐ¸ Ð¸ÑÐ¿ÑÐ°Ð²Ð»ÑÑÑ ÑÐ¶Ðµ Ð¿Ð¾Ð·Ð´Ð½Ð¾.
        const volumeHint = engineVolumeHint(car);
        if (volumeHint) {
          alert.error(volumeHint, { autoClose: false, closeOnClick: false });
        }
        resolvedContainerIdRef.current = car?.container?.id ?? null;
        
        let transmissionDefaultValue = null;
        if (car?.transmission?.id) {
          transmissionDefaultValue = { value: car.transmission.id, label: car.transmission.title };
        } else if (car?.transmissionId) {
          try {
            const transRes = await getTransmissions();
            const found = transRes.data.find(t => t.id === car.transmissionId);
            if (found) {
              transmissionDefaultValue = { value: found.id, label: found.title };
            }
          } catch (e) {
            console.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ transmissions:', e);
          }
        }
        
        let originDefaultValue;
        if (car?.originCarId === CAR_ORIGIN_TYPES.NEW_KZ && car?.factoryId) {
          const factory = factoryList.find((f) => f.id === car.factoryId);
          if (factory) {
          originDefaultValue = {
              value: `factory_${factory.id}`,
              label: factory.id === USED_CAR_FACTORY_ID ? factory.name : 'ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾, ' + factory.name,
              factoryId: factory.id,
              isUsedFactory: factory.id === USED_CAR_FACTORY_ID,
            };
            setFactoryId(car.factoryId);
          } else {
            originDefaultValue = {
              value: CAR_ORIGIN_TYPES.NEW_KZ,
              label: CAR_ORIGIN_LABELS[CAR_ORIGIN_TYPES.NEW_KZ],
            };
          }
        } else {
          originDefaultValue = {
            value: car?.originCarId,
            label: CAR_ORIGIN_LABELS[car?.originCarId],
          };
        }

        // Ð¢ÐµÐºÑÑÐ¸Ðµ ÐÐ¦ Ð¼Ð°ÑÐ¸Ð½Ñ. ÐÐ¾Ð´Ð´ÐµÑÐ¶Ð¸Ð²Ð°ÐµÐ¼ ÑÐ°Ð·Ð½ÑÐµ ÑÐ¾ÑÐ¼Ñ Ð¿Ð¾Ð»Ñ Ñ Ð±ÑÐºÐ°:
        // Ð¼Ð°ÑÑÐ¸Ð² id ([5, 7]) Ð»Ð¸Ð±Ð¾ Ð¼Ð°ÑÑÐ¸Ð² Ð¾Ð±ÑÐµÐºÑÐ¾Ð² ([{ id, name }] / [{ dcId }]).
        // ÐÐ²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÑÐµÐ¼ ÑÐµÐ¼Ð¸ Ð¶Ðµ Ð¿ÑÐ°Ð²Ð¸Ð»Ð°Ð¼Ð¸, ÑÑÐ¾ Ð¸ ÑÐ¾Ð·Ð´Ð°ÑÐ¼:
        // ÑÐ¾Ð²Ð½Ð¾ Ð¾Ð´Ð¸Ð½ ÐÐ¦ Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ¡Ð, Ð¿Ð»ÑÑ Ð¿Ð¾Ð»Ñ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÐ°.
        const isConsignment = isConsignmentOrigin(car?.originCarId);
        // Ð¡Ð¿Ð¸ÑÐ¾Ðº ÐÐ¦ Ð¿Ð¾ ÑÐ¸Ð¿Ñ Ð¼Ð°ÑÐ¸Ð½Ñ: ÐÐ£ (Ð²ÑÐºÑÐ¿, Ð¼ÐµÐ½Ð°, Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ, Ð·Ð°Ð²Ð¾Ð´ ÐÐ£) â ÑÐ¾Ð»ÑÐºÐ¾
        // ÐÐ¡Ð, Ð½Ð¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾ â ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð»Ð¾Ð½Ñ. ÐÐ½Ð°ÑÐµ Ð½Ð¾Ð²Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ðµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ Ð¿Ð¾ÑÑÐ°Ð²Ð¸ÑÑ
        // ÐÐ¡Ð, Ð° ÐÐ£ â ÑÐ°Ð»Ð¾Ð½, Ð¸ Ð±Ð°Ð½ÐºÐ¸ Ð¿Ð¾Ð»ÑÑÐ°Ð»Ð¸ Ð½Ðµ ÑÑ ÑÐ¾ÑÐºÑ.
        const isCarUsedNow =
          car?.used || car?.factoryId === USED_CAR_FACTORY_ID || PURCHASE_PROCESS_TYPES.includes(car?.originCarId);

        const currentDc = car?.dcIds || car?.dcs || car?.dealerCenters || [];
        const dcDefaultValue = (Array.isArray(currentDc) ? currentDc : [])
          .map((dc) => {
            if (dc == null) return null;
            if (typeof dc === 'object') {
              const value = dc.id ?? dc.dcId ?? dc.value;
              if (value == null) return null;
              return { value, label: dc.name ?? dc.label ?? String(value) };
            }
            return { value: dc, label: String(dc) };
          })
          .filter(Boolean);

        const carInfo = [
          {
            component: Select,
            name: 'origin',
            label: 'ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¸Ð¿ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ',
            options: originOptions,
            rules: { required: true },
            defaultValue: originDefaultValue,
            onChangeCustom: (selectedOption) => {
              const newValue = selectedOption?.value;
              if (typeof newValue === 'string' && newValue.startsWith('factory_')) {
                const selectedFactoryId = selectedOption.factoryId;
                setFactoryId(selectedFactoryId);
              } else {
                setFactoryId(null);
              }
            },
          },
          {
            name: 'mark',
            component: SelectMarks,
            label: 'ÐÐ°ÑÐºÐ°',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            defaultValue: { value: car?.container?.mark?.id, label: car?.container?.mark?.name },
            onChangeCustom: () => {
              resolvedContainerIdRef.current = null;
            },
          },
          {
            name: 'model',
            component: SelectModels,
            dependency: 'mark',
            dependencyAccessor: (obj) => obj?.value,
            label: 'ÐÐ¾Ð´ÐµÐ»Ñ',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            defaultValue: { value: car?.container?.model?.id, label: car?.container?.model?.name },
            onChangeCustom: (modelOption, markOption) => {
              resolveContainerId({ markOption, modelOption });
            },
          },
          {
            name: 'complect',
            component: SelectComplectations,
            dependency: ['mark', 'model'],
            dependencyAccessor: (arr) => arr?.map((o) => o?.value).join('|'),
            label: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            defaultValue: { value: car?.complectation?.id, label: car?.complectation?.title },
            params: () => resolvedContainerIdRef.current,
          },
          {
            name: 'issueYear',
            label: 'ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°',
            defaultValue: car.issueYear,
            rules: {
              validate: (value) => {
                if (value < 1900 || value > dayjs().year()) {
                  return 'ÐÐµÐ´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐ¹ Ð³Ð¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°';
                }

                return true;
              },
            },
          },
          { name: 'vin', label: 'VIN', defaultValue: car.vin },
          ...(isConsignment
            ? [
                {
                  name: 'texNumber',
                  label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÐ°',
                  placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð½Ð¾Ð¼ÐµÑ',
                  defaultValue: car?.texNumber,
                },
                {
                  name: 'texDate',
                  component: Datepicker,
                  label: 'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÐ°',
                  placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³',
                  defaultValue: car?.texDate,
                },
              ]
            : []),
          { name: 'color', label: 'Ð¦Ð²ÐµÑ ÐºÑÐ·Ð¾Ð²Ð°', color: car.color, defaultValue: car.color },
          { name: 'engine_volume', label: 'ÐÐ±ÑÐµÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ', defaultValue: car.engine_volume,
            // ÐÐ±ÑÑÐ¼ ÑÐºÐ°Ð·ÑÐ²Ð°ÐµÑÑÑ Ð² ÐºÑÐ±Ð¸ÑÐµÑÐºÐ¸Ñ ÑÐ°Ð½ÑÐ¸Ð¼ÐµÑÑÐ°Ñ Ð¸ ÑÑÐ¾Ð´Ð¸Ñ Ð² Ð±Ð°Ð½ÐºÐ¸: Ð¾Ð½Ð¸ Ð¸ÑÑÑ
            // Ð¼Ð°ÑÐ¸Ð½Ñ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ, Ð¼Ð¾Ð´ÐµÐ»Ð¸, Ð³Ð¾Ð´Ñ Ð¸ Ð¾Ð±ÑÑÐ¼Ñ ÑÑÐ°Ð·Ñ. ÐÑÐ¸Ð±ÐºÐ° Ð·Ð´ÐµÑÑ
            // Ð¾Ð·Ð½Ð°ÑÐ°ÐµÑ Ð¾ÑÐºÐ°Ð· Â«Ð¼Ð¾Ð´ÐµÐ»Ñ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð° Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµÂ» ÑÐ¶Ðµ Ð¿Ð¾ÑÐ»Ðµ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð·Ð°ÑÐ²ÐºÐ¸.
            rules: {
              validate: (value) => {
                if (!value.match(/^[0-9]+$/)) {
                  return 'ÐÐµÐ´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ';
                }

                const liters = Number(value) / 1000;
                if (liters < 0.6 || liters > 8) {
                  return 'ÐÐ¾ÑÐ¾Ð¶Ðµ Ð½Ð° Ð¾Ð¿ÐµÑÐ°ÑÐºÑ: ÑÐºÐ°Ð¶Ð¸ÑÐµ Ð¾Ð±ÑÑÐ¼ Ð² ÐºÑÐ±Ð¸ÑÐµÑÐºÐ¸Ñ ÑÐ°Ð½ÑÐ¸Ð¼ÐµÑÑÐ°Ñ, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ 1499';
                }

                return true;
              },
            }
          },
          { name: 'engine', label: 'Ð¢Ð¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ', defaultValue: car?.complectation?.engine?.title },
          {
            name: 'transmission',
            component: SelectCarTransmissions,
            label: 'Ð¢Ð¸Ð¿ ÐºÐ¾ÑÐ¾Ð±ÐºÐ¸ Ð¿ÐµÑÐµÐ´Ð°Ñ',
            defaultValue: transmissionDefaultValue,
          },
          {
            name: 'mileage',
            label: 'ÐÑÐ¾Ð±ÐµÐ³, ÐºÐ¼',
            defaultValue: car?.mileage,
            format: 'number',
            rules: {
              validate: (value, getValues) => {
                const origin = getValues('origin');
                const originValue = origin?.value;
                const isUsed = typeof originValue === 'string' && originValue.startsWith('factory_')
                  ? origin?.isUsedFactory
                  : PURCHASE_PROCESS_TYPES.includes(originValue);
                if (isUsed && (!value || value.toString().trim() === '')) {
                  return 'ÐÑÐ¾Ð±ÐµÐ³ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÐµÐ½ Ð´Ð»Ñ Ð±/Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹';
                }
                return true;
              },
            },
          },
          { name: 'price', label: 'Ð Ð Ð¦, KZT', defaultValue: formatNumber(car?.price), format: 'number' },
          {
            component: SelectCity,
            name: 'city',
            label: 'ÐÐ¾ÑÐ¾Ð´',
            defaultValue: { value: car?.city?.id, label: car?.city?.title },
          },
          {
            component: SelectDc,
            name: 'dc',
            label: 'ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            isMulti: !isConsignment,
            used: !!isCarUsedNow,
            defaultValue: isConsignment ? dcDefaultValue[0] ?? null : dcDefaultValue,
          },
          {
            name: 'status',
            label: 'Ð¡ÑÐ°ÑÑÑ',
            defaultValue: checkStockCar(car?.checkStock) ? 'Ð Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸' : 'ÐÐµÑ Ð² Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸',
            disabled: true,
          },
        ];

        setCarInfo(carInfo);
        checkCrmSidebarNotifications({ notificationIds: car?.notifications?.map((i) => i?.id) });
        onSavedRef.current?.(car);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [factoryList, originOptions, containerId, id]);

  useEffect(() => {
    loadFactoryList();
  }, []);

  // ÐÐ°ÑÐ¸Ð½Ñ Ð³ÑÑÐ·Ð¸Ð¼ Ð¿Ð¾ÑÐ»Ðµ Ð¾ÑÐ²ÐµÑÐ° ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ° Ð·Ð°Ð²Ð¾Ð´Ð¾Ð², Ð° Ð½Ðµ Ð¿Ð¾ÑÐ»Ðµ Ð½ÐµÐ¿ÑÑÑÐ¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ°:
  // Ð½Ð° JetQ Ð·Ð°Ð²Ð¾Ð´Ð¾Ð² Ð½ÐµÑ, Ð¸ ÐºÐ°ÑÑÐ¾ÑÐºÐ° ÐºÑÑÑÐ¸Ð»Ð° ÑÐ¿Ð¸Ð½Ð½ÐµÑ Ð±ÐµÑÐºÐ¾Ð½ÐµÑÐ½Ð¾ (Ð¼Ð°ÑÐ¸Ð½Ð° 146).
  React.useEffect(() => {
    if (factoryListLoaded) {
      init();
    }
  }, [factoryListLoaded, init]);

  const sellCar = () => {
    navigate('/deals/create', { state: { car } });
  };

  const saveCar = (payload) => {
    if (!payload?.vin || payload?.vin?.trim()?.length !== 17) {
      alert.error('ÐÐ»Ð¸Ð½Ð° VIN Ð´Ð¾Ð»Ð¶Ð½Ð° Ð±ÑÑÑ 17 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²');
      return;
    }

    setLoading(true);
    
    const originValue = payload?.origin?.value;
    const finalOrigin = typeof originValue === 'string' && originValue.startsWith('factory_') 
      ? CAR_ORIGIN_TYPES.NEW_KZ 
      : originValue;

    const isUsedFactory = typeof originValue === 'string' && originValue.startsWith('factory_')
      ? payload?.origin?.isUsedFactory || factoryId === USED_CAR_FACTORY_ID
      : false;
    // Ð¢Ð° Ð¶Ðµ Ð»Ð¾Ð³Ð¸ÐºÐ°, ÑÑÐ¾ Ð¿ÑÐ¸ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ð¸ (CarCreate): Ð²ÑÐºÑÐ¿ Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°, Ð·Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ðµ,
    // Ð¼ÐµÐ½Ð° Ð¸ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ â ÑÑÐ¾ ÐÐ£. Ð Ð°Ð½ÑÑÐµ Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ ÑÐ»Ð°Ð³
    // ÑÑÐ°Ð²Ð¸Ð»ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Ð·Ð°Ð²Ð¾Ð´Ð° ÐÐ£, Ð¸ Ð¼Ð°ÑÐ¸Ð½Ð° Â«Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸ÑÂ» Ð¿Ð¾ÑÐ»Ðµ
    // Ð¾Ð±ÑÑÐ½Ð¾Ð³Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ñ ÑÑÐ¾Ð´Ð¸Ð»Ð° Ð² Ð±Ð°Ð½ÐºÐ¸ ÐºÐ°Ðº Ð½Ð¾Ð²Ð°Ñ (ÑÐ´ÐµÐ»ÐºÐ° 191340).
    const isCarUsed = typeof originValue === 'string' && originValue.startsWith('factory_')
      ? isUsedFactory
      : PURCHASE_PROCESS_TYPES.includes(finalOrigin);

    const editPayload = {
      ...payload,
      price: parseInt(payload?.price?.replace(/\s/g, '')),
      complectationId: payload?.complect?.value,
      transmissionId: payload?.transmission?.value,
      cityId: payload?.city?.value,
      markId: payload?.mark?.value,
      modelId: payload?.model?.value,
      vin: payload?.vin?.trim(),
      originCarId: finalOrigin,
      used: isCarUsed,
      mileage: payload?.mileage ? parseInt(payload?.mileage?.replace(/\s/g, '')) : undefined,
      factoryId,
      dcIds: [].concat(payload?.dc || []).map((dc) => dc?.value).filter((v) => v != null),
      texDate: payload?.texDate ? dayjs(payload.texDate).format('YYYY-MM-DD') : undefined,
    };

    editCar(containerId || id, editPayload)
      .then((res) => {
        init();
        alert.success('ÐÐ°Ð½Ð½ÑÐµ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ñ');
      })
      .catch((err) => {
        alert.error(err?.response?.data?.errorMessage || 'ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ Ð´Ð°Ð½Ð½ÑÑ');
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div style={{ paddingBottom: '20px' }}>
          <ForeignCityNotice city={car?.city} />
          {/* <Form inputs={dealerInfo} title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð´Ð¸Ð»ÐµÑÑÐºÐ¾Ð¼ ÑÐµÐ½ÑÑÐµ'} grid={formStyles.dealerInfo} border />
      <Form inputs={other} title={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾'} grid={formStyles.other} border /> */}
          <HookForm inputs={carInfo} border grid={formStyles.carInfo} onSubmit={saveCar} action="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ" />
          {car?.mark && !containerId && checkStockCar(car?.checkStock) ? (
            <Button text={'ÐÑÐ¾Ð´Ð°ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ'} fill onClick={sellCar} />
          ) : null}
        </div>
      )}
    </>
  );
};

export default CarMainData;
